import { Injectable } from '@angular/core';

import { Observable, of, ReplaySubject } from 'rxjs';

import { Event } from '@mirage-projects/communication-library';
import { EXTERNAL_COMMUNICATION_EVENTS, ExternalCommunicationService } from '@mirage-projects/cw-commons';

import { ScanHelperService } from '../scan/scan-helper.service';

/**
 * This service manages some of the external events without having the project opened
 */
@Injectable({ providedIn: 'root' })
export class GeneralExternalEventsService {
    constructor(
        private externalCommunicationService: ExternalCommunicationService,
        private scanHelperService: ScanHelperService
    ) {}

    private onCurrentStationResponseSubject = new ReplaySubject<Event>(1);
    onCurrentStationResponse$ = this.onCurrentStationResponseSubject.asObservable();

    init(): Observable<void> {
        this.registerScanEventSubscriptions();
        return of();
    }

    private registerScanEventSubscriptions(): void {
        this.externalCommunicationService.onEvents(EXTERNAL_COMMUNICATION_EVENTS.SET_SCANNER_STATE_RESPONSE).subscribe((event) => {
            if (!event.message?.success) {
                throw new Error(`WorkflowServiceScan error with event ${EXTERNAL_COMMUNICATION_EVENTS.SET_SCANNER_STATE_RESPONSE}`);
            }
            this.scanHelperService.connectScan(event.message.state, event.message.type);
        });

        /** We need to do an early subscribe and replay of this message because it arrives too soon */
        this.externalCommunicationService
            .onEvents(EXTERNAL_COMMUNICATION_EVENTS.SET_CURRENT_STATION_RESPONSE)
            .subscribe((event) => this.onCurrentStationResponseSubject.next(event));
    }
}
